import { render, staticRenderFns } from "./list-pro.vue?vue&type=template&id=0fb757f7&scoped=true"
import script from "./list-pro.vue?vue&type=script&lang=js"
export * from "./list-pro.vue?vue&type=script&lang=js"
import style0 from "./list-pro.vue?vue&type=style&index=0&id=0fb757f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb757f7",
  null
  
)

export default component.exports